module.exports = __webpack_public_path__ + "img/mcp.ca61eae0.svg";